import React from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import MobileOtp from "./MobileOtp";
import EmailOtp from "./EmailOtp";
import { useContext } from "react";
import { AppContext } from "../context/AppContext";
import { Select } from "../Helper";
import AddressForm from "../shared/AddressForm";

const EntityDetail = ({
  formInputData,
  setFormInputData,
  handleInputChange,
  addressRef,
  mobileRef,
  emailRef,
}) => {
  const apiEndPoint = process.env.REACT_APP_API_ENDPOINT;
  const lobUrl = "/LoBForSelect/";
  const utUrl = "/UserTypeForSelect/";
  const [setLoaderActive] = useContext(AppContext);
  return (
    <fieldset>
      <legend>Business Entity Details</legend>
      <Row xs={1} sm={1} md={3}>
        <Col className="mb-sm-0 mb-3">
          <Form.Group>
            <Form.Control
              // size="lg"
              type="text"
              placeholder="Business Name"
              required
              name="bpName"
              value={formInputData.bpName}
              onChange={handleInputChange}
              minLength="5"
              maxLength="50"
            />
            <Form.Control.Feedback>Looks good!</Form.Control.Feedback>
          </Form.Group>
        </Col>
        <Col className="mb-sm-0 mb-3">
          <Select
            inputProps={{
              // size: "lg",
              name: "lob_id",
              value: formInputData.lob_id,
              onChange: handleInputChange,
            }}
            dataUrl={lobUrl}
            defaultLabel="Select LoB"
          ></Select>
        </Col>
        <Col className="mb-sm-0 mb-3">
          <Select
            inputProps={{
              name: "user_type_id",
              value: formInputData.user_type_id,
              onChange: handleInputChange,
            }}
            dataUrl={utUrl}
            defaultLabel="Select User Type"
          ></Select>
        </Col>
      </Row>
      <Card className="mt-3 mb-3">
        <Card.Header as="h5">Primary Contact Details</Card.Header>
        <Card.Body>
          <Row xs={1} sm={1} md={2}>
            <Col>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="First Name"
                  required
                  name="firstName"
                  value={formInputData.firstName}
                  onChange={handleInputChange}
                  minLength="3"
                  maxLength="50"
                />
              </Form.Group>
              <Form.Group className="mb-3">
                <Form.Control
                  type="text"
                  placeholder="Last Name"
                  required
                  name="lastName"
                  value={formInputData.lastName}
                  onChange={handleInputChange}
                  minLength="3"
                  maxLength="50"
                />
              </Form.Group>
              <MobileOtp ref={mobileRef} unique={true} />
              <EmailOtp ref={emailRef} unique={true} />
            </Col>
            <Col>
              <Card>
                <Card.Header as="h6">Address Details</Card.Header>
                <Card.Body>
                  <AddressForm ref={addressRef} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Card.Body>
      </Card>
    </fieldset>
  );
};

export default EntityDetail;
